import {
    createAsyncThunk,
    createSelector,
    createSlice,
  } from "@reduxjs/toolkit";
  import httpRequest from "../../services/httpRequest";
  import { saveAs } from 'file-saver';
  import snakecaseKeys from 'snakecase-keys';
  import { PAGINATION } from "config/AppConfig";
  // Main URL Endpoint
  const _urlPrefix = "/import-staff";
  
  export const downloadTemplate = createAsyncThunk(
    "importStaff/downloadTemplate",
    async () => {
        const result = await httpRequest({
            url: `${_urlPrefix}/download-template`,
            method: "GET"
        });
        if (!result) {
            return;
        }
        const blob = new Blob(['\ufeff', result], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, 'Template-Import-Staff-CSV.csv');
        return result.data;
    }
  );
  
  export const loadImportWorker = createAsyncThunk(
    "importStaff/loadImportWorker",
    async (params) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/page`,
        method: "GET",
        params
      });
      if (!result) {
        return;
      }
      return result.data;
    }
  );
  
  export const uploadWorkerCSV = createAsyncThunk(
    "importStaff/uploadWorkerCSV",
    async (params, { dispatch, getState }) => {
      const { fileImport, isOverride } = params;
      const contentData = { isOverride };
  
      const data = new FormData();
      data.append('file', fileImport);
      data.append('import-csv-request', new Blob([JSON.stringify(snakecaseKeys(contentData))], {
        type: 'application/json'
      }));
      const result = await httpRequest({
        url: `${_urlPrefix}/upload-csv`,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data,
        successMessage: "toast.import.200"
      });
      if (!result) {
        return;
      }
      const state = getState().importStaff;
      dispatch(loadImportWorker({
        page: 1,
        size: state.cachedSize,
        search_key: state.cachedSearchKey
      }));
      dispatch(checkImportWorkerProgress());
      return result.data;
    }
  );
  
  export const downloadWorkerFileLogs = createAsyncThunk(
    "importStaff/downloadWorkerFileLogs",
    async (params) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/download-error-file`,
        method: "GET",
        params: {
          id: params.id
        }
      });
      if (!result) {
        return;
      }
      const blob = new Blob(['\ufeff', result], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, params.fileName);
      return result.data;
    }
  );
  
  export const checkImportWorkerProgress = createAsyncThunk(
    "importStaff/checkImportWorkerProgress",
    async (params, { dispatch, getState }) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/check-import-worker-progress`,
        method: "GET"
      });
      if (!result) {
        return;
      }
      if (result.data.length === 0) {
        const state = getState().importStaff;
        dispatch(loadImportWorker({
          page: state.cachedPage,
          size: state.cachedSize,
          search_key: state.cachedSearchKey
        }));
      }
      return result.data;
    }
  );
  
  const initialState = {
    importWorkers: [],
    paginationImport: {
      ...PAGINATION
    },
    listWrorkerProgressNote: [],
    progressingFiles: [],
    isUploadWorkerCSV: false,
    isImportError: false,
    cachedPage: 1,
    cachedSize: 10,
    cachedSearchKey: "",
  };
  
  const importStaff = createSlice({
    name: "importStaff",
    initialState: initialState,
    reducers: {
      setImportWorkerCachedPage: (state, { payload }) => {
        state.cachedPage = payload;
      },
      setImportWorkerCachedSize: (state, { payload }) => {
        state.cachedSize = payload;
      },
      setImportWorkerCachedSearchKey: (state, { payload }) => {
        state.cachedSearchKey = payload;
      },
    },
    extraReducers: {
        [loadImportWorker.pending]: (state, action) => {
            const { meta: { arg } } = action;
            state.paginationImport = {
                ...state.paginationImport,
                ...arg
            };
        },
        [loadImportWorker.fulfilled]: (state, action) => {
            const { payload } = action;
            if (payload) {
                state.importWorkers = [...payload.content];
                state.paginationImport.size = payload.pageSize;
                state.paginationImport.totalRecords = payload.totalElements;
                state.paginationImport.totalPages = payload.totalPages;
                state.paginationImport.page = payload.pageNumber;
                state.paginationImport = { ...state.paginationImport };
            }
            return state;
        },
        [uploadWorkerCSV.pending]: (state) => {
                state.isUploadWorkerCSV = true
                state.isImportError = false;
            return state;
        },
        [uploadWorkerCSV.fulfilled]: (state) => {
                state.isUploadWorkerCSV = false;
                return state;
        },
        [uploadWorkerCSV.rejected]: (state) => {
            state.isUploadWorkerCSV = false;
            state.isImportError = true;
            return state;
        },
        [checkImportWorkerProgress.fulfilled]: (state, action) => {
            const { payload } = action;
            state.progressingFiles = [...payload];
            return state;
        },
    }
  });
  
  const { reducer, actions } = importStaff;
  export const { setImportWorkerCachedPage, setImportWorkerCachedSize, setImportWorkerCachedSearchKey } = actions;
  export default reducer;
  

export const fetchImportWorkers = createSelector(
    state => state.importStaff.importWorkers,
    importWorkers => importWorkers
);
  
export const fetchPaginationImport = createSelector(
    state => state.importStaff.paginationImport,
    paginationImport => paginationImport
);
  
export const fetchProgressingWorkerFiles = createSelector(
    state => state.importStaff.progressingFiles,
    progressingFiles => progressingFiles
);
  
export const fetchFileNameWorkerImport = createSelector(
    state => state.importStaff.fileNameImport,
    fileNameImport => fileNameImport
);
  
export const getIsUploadWorkerCSV = createSelector(
    state => state.importStaff.isUploadWorkerCSV,
    isUploadWorkerCSV => isUploadWorkerCSV
);

export const getImportWorkerCachedPage = createSelector(
    state => state.importStaff.cachedPage,
    cachedPage => cachedPage
);

export const getImportWorkerCachedSize = createSelector(
    state => state.importStaff.cachedSize,
    cachedSize => cachedSize
);

export const getImportWorkerCachedSearchKey = createSelector(
    state => state.importStaff.cachedSearchKey,
    cachedSearchKey => cachedSearchKey
);
  